import React from 'react'

const Logo = () => {
  return (
    <div className='fastLogo'>
        <img src="/fastLogoNew.svg" alt="Fast Heroes Logo" />
    </div>
  );
};

export default Logo